var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDocsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.155,
    height: 80.644,
    viewBox: "0 0 132.155 80.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NoDocuments",
    transform: "translate(0 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83155",
    "data-name": "Path 83155",
    d: "M173.616,65a5.539,5.539,0,1,1,0,11.079H141.962a5.539,5.539,0,1,1,0,11.079h17.41a5.539,5.539,0,1,1,0,11.079H151.32c-3.857,0-6.984,2.48-6.984,5.539q0,3.059,4.748,5.539a5.539,5.539,0,1,1,0,11.079H83.4a5.539,5.539,0,1,1,0-11.079H52.539a5.539,5.539,0,0,1,0-11.079H84.193a5.539,5.539,0,1,0,0-11.079H64.41a5.539,5.539,0,0,1,0-11.079H96.064a5.539,5.539,0,0,1,0-11.079Zm0,22.158a5.539,5.539,0,1,1-5.539,5.539A5.539,5.539,0,0,1,173.616,87.158Z",
    transform: "translate(-47 -54.119)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83156",
    "data-name": "Path 83156",
    d: "M140.027,64l7.361,53.687.661,5.386a3.165,3.165,0,0,1-2.755,3.528l-46.342,5.69a3.165,3.165,0,0,1-3.527-2.756L88.29,71.428a1.583,1.583,0,0,1,1.378-1.764l.016,0,3.845-.431m3.109-.349,3.63-.407Z",
    transform: "translate(-55.613 -53.91)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83157",
    "data-name": "Path 83157",
    d: "M140.746,63.6a.989.989,0,0,0-1.96.269Zm6.381,53.822.981-.121a.088.088,0,0,0,0-.013Zm.661,5.386.982-.12Zm-2.755,3.528.12.981Zm-46.342,5.69.121.982Zm-3.527-2.756.982-.12ZM89.424,69.4l.11.983Zm3.955.552a.989.989,0,1,0-.221-1.966Zm2.888-2.315a.989.989,0,1,0,.22,1.966Zm3.85,1.559a.989.989,0,0,0-.22-1.966Zm38.669-5.324,7.361,53.688,1.96-.269L140.746,63.6Zm7.36,53.673.662,5.386,1.963-.241-.662-5.387Zm.662,5.386a2.176,2.176,0,0,1-1.9,2.425l.241,1.963a4.154,4.154,0,0,0,3.617-4.629Zm-1.9,2.425-46.341,5.69.241,1.964,46.341-5.691Zm-46.341,5.69a2.176,2.176,0,0,1-2.425-1.894l-1.964.241a4.155,4.155,0,0,0,4.63,3.617Zm-2.425-1.894L89.011,71.047l-1.964.241L94.182,129.4ZM89.011,71.047a.594.594,0,0,1,.517-.661l-.241-1.964a2.572,2.572,0,0,0-2.239,2.866Zm.517-.661h.006l-.22-1.966-.027,0Zm.006,0,3.845-.431-.221-1.966-3.845.431Zm6.954-.78,3.63-.407-.22-1.966-3.63.407Z",
    transform: "translate(-55.352 -53.649)",
    fill: "#1f64e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83158",
    "data-name": "Path 83158",
    d: "M138.925,68.269l6.663,48.655.6,4.881A2.852,2.852,0,0,1,143.723,125l-41.5,5.1a2.852,2.852,0,0,1-3.163-2.5L92.611,75.065A1.583,1.583,0,0,1,93.989,73.3l5.134-.63",
    transform: "translate(-56.514 -54.801)",
    fill: "#e8f0fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83159",
    "data-name": "Path 83159",
    d: "M110.1,51.25H146.15a2.177,2.177,0,0,1,1.538.637l10.638,10.632a2.176,2.176,0,0,1,.638,1.539v49.511a2.176,2.176,0,0,1-2.176,2.176H110.1a2.176,2.176,0,0,1-2.176-2.176V53.426A2.176,2.176,0,0,1,110.1,51.25Z",
    transform: "translate(-59.711 -51.25)",
    fill: "#fff",
    stroke: "#1f64e7",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83160",
    "data-name": "Path 83160",
    d: "M156.672,52.4V61.58a2.374,2.374,0,0,0,2.374,2.374h6.278",
    transform: "translate(-69.883 -51.491)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83161",
    "data-name": "Path 83161",
    d: "M118,107.359h20.575M118,67h0Zm0,9.5h0Zm0,10.288h0Zm0,10.288h0Z",
    transform: "translate(-61.814 -54.536)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocsIcon);
export default __webpack_public_path__ + "static/media/upload-docs-icon.1219d77b7ad4b37feca9197e8d51b41d.svg";
export { ForwardRef as ReactComponent };